export default "__VITE_ASSET__wOthqK$9__"